import { getDiscoverySessionId } from './discoverySession.js';
import { pickPrimaryApplicationTypeId } from './pickPrimaryApplicationType.js';

/**
 * Persist advisor advise result into durable discovery session (server).
 * Safe to call fire-and-forget from citizen demos.
 */
export async function persistAdviseToDiscoverySession({
  structuredOutput,
  formPrefill,
  packageId,
  portalVariant,
  preferredApplicationTypeId = null,
} = {}) {
  try {
    const sessionId = getDiscoverySessionId();
    if (!sessionId) return null;
    const out = structuredOutput?.result || structuredOutput || {};
    const routing = out.routing || structuredOutput?.routing || null;
    const handoffPacket = out.handoffPacket
      || structuredOutput?.handoffPacket
      || null;
    const applicationTypeId = pickPrimaryApplicationTypeId(
      {
        ...(routing || {}),
        applicationTypes: routing?.applicationTypes || handoffPacket?.applicationTypes,
        applicationTypeIds: routing?.applicationTypeIds || handoffPacket?.applicationTypeIds,
      },
      preferredApplicationTypeId,
    )
      || handoffPacket?.applicationTypes?.[0]?.id
      || null;

    const { saveDiscoverySessionApi } = await import('../api/applicationType.api.js');
    const data = await saveDiscoverySessionApi({
      sessionId,
      packageId: packageId || handoffPacket?.jurisdictionId || null,
      portalVariant: portalVariant || 'default',
      phase: applicationTypeId ? 'identified' : 'discovery',
      applicationTypeId,
      formPrefill: formPrefill || out.form_prefill || handoffPacket?.formPrefill || {},
      routing,
      parcel: out.parcel || structuredOutput?.parcel || null,
      landUse: out.landUse || structuredOutput?.landUse || null,
      fees: out.fees || structuredOutput?.fees || null,
      requirements: out.requirements || structuredOutput?.requirements || null,
      handoffPacket,
    });
    return data?.session || null;
  } catch (_) {
    return null;
  }
}

export function intakePathForSession({
  sessionId, city, packageId, applicationTypeId, type,
} = {}) {
  const id = sessionId || getDiscoverySessionId();
  const params = new URLSearchParams();
  if (id) params.set('session', id);
  if (city || packageId) params.set('city', city || packageId);
  const appType = applicationTypeId || type;
  if (appType) params.set('type', appType);
  const q = params.toString();
  return `/v2/demo/permit/intake${q ? `?${q}` : ''}`;
}

/** Advisor deep-link that keeps the discovery session when leaving intake. */
export function advisorPathForSession({
  sessionId, city, packageId, basePath = '/v2/demo/permit',
} = {}) {
  const id = sessionId || getDiscoverySessionId();
  const params = new URLSearchParams();
  if (city || packageId) params.set('city', city || packageId);
  if (id) params.set('session', id);
  const q = params.toString();
  return `${basePath}${q ? `?${q}` : ''}`;
}
